// extracted by mini-css-extract-plugin
export var counterGroup = "eventCountdown-module--counter-group--1949f";
export var counterGroupItem = "eventCountdown-module--counter-group-item--ed4b8";
export var eventCountdown = "eventCountdown-module--event-countdown--dc2b7";
export var labeledCounter = "eventCountdown-module--labeled-counter--047a7";
export var labeledCounterCount = "eventCountdown-module--labeled-counter-count--bf4ff";
export var labeledCounterLabel = "eventCountdown-module--labeled-counter-label--057f2";